export default __webpack_public_path__ + "a881ee531230aec54bab7cb2284c56af.png";